module.exports = __webpack_public_path__ + "img/good-bye-feedback.fe410797.svg";